export default "__VITE_ASSET__c83tp18T__"